import {getFinalizeOrderRedirectPath} from '../../../../utils/getFinalizeOrderRedirectPath';
import {getLanguagePath} from '../../../../utils/language';

const PARSE_BASE = 'https://same-origin.invalid';

const isSafeRelativePath = (path: string) =>
  path.startsWith('/') && new URL(path, PARSE_BASE).origin === PARSE_BASE;

export function getRedirectPath(search: string, pathname: string) {
  const finalizeOrderPath = getFinalizeOrderRedirectPath(search, pathname);
  if (finalizeOrderPath) {
    return finalizeOrderPath;
  }

  const route = new URLSearchParams(search).get('route');
  if (route && isSafeRelativePath(route)) {
    return route;
  }

  return `${getLanguagePath(pathname)}/`;
}
